export default {
  actions: {
    PRESIGNED_URL: 'PRESIGNED_URL',
    UPLOAD_IMAGE: 'UPLOAD_IMAGE',
    UPDATE_COMMERCE_BANNER: 'UPDATE_COMMERCE_BANNER',
    REGISTER_ICON_COMMERCE_KIND: 'REGISTER_ICON_COMMERCE_KIND',
  },
};
